import styled, { css } from 'styled-components'
import posed from 'react-pose'
import { Link } from 'react-router-dom'

export const ListItemStyled = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    margin: 10px 0;
    border-radius: 4px;
    box-shadow: 0 6px 18px 0 ${({ theme }) => theme.blueyGrey22};
    background-color: ${(props) => props.active ? props.theme.whiteTwo : props.theme.white};
    border: ${({ theme }) => `1px solid ${theme.whiteTwo}`};
    cursor: ${({ pointer }) => pointer ? 'pointer' : 'auto'};
    ${({ bordercolor }) =>
        bordercolor &&
        css`
           border: ${({ bordercolor }) => `2px solid ${bordercolor}`};
        `
    };
`

export const StyledLink = styled(Link)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    ${({ hidden }) =>
        hidden &&
        css`
            display: none;
        `
    }
`

export const StyledDivider = styled.div`
    width: 2px;
    align-self: stretch;
    background-color: ${({ theme }) => theme.veryLightPink};
    margin-right: 15px;
`

const StyledEditWrapperPosed = posed.div({
    hidden: { width: '0px', opacity: 0 },
    visible: { width: '56px', opacity: 1 }
});

export const StyledEditWrapper = styled(StyledEditWrapperPosed)`
    display: flex;
    align-items: center;
    overflow: hidden;
    align-self: stretch;
`

export const ListContainer = styled.div`
    flex: 1;
    margin-right: 20px;
    ${({ noMargin }) =>
        noMargin &&
        css`
        margin: 0;
    `}
`

export const ListWrap = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 10px;
    &:first-child {
        margin-top: 0;
    }
`

export const ListTitle = styled.div`
    font-size: 20px;
    letter-spacing: 0.6px;
    font-weight: 700;
    color: ${({ theme }) => theme.gretishBrown};
    ${props =>
        props.loading &&
        css`
           width: 80px;
           height: 23px;
           background: ${({ theme }) => theme.blueyGrey22};
           border-radius: 2px;
        `
    };
`

export const StyledListSubtitle = styled.div`
    font-size: 20px;
    letter-spacing: 0.6px;
    font-weight: 700;
    color: ${({ theme }) => theme.brownGrey};
    margin-left: 10px;
`

export const ListTags = styled.div`
    font-size: 15px;
    letter-spacing: 0.5px;
    font-weight: ${(props) => props.bold ? 700 : 400};
    color: ${({ red, theme }) => red ? theme.pastelRed : theme.gretishBrown};
    ${props =>
        props.loading &&
        css`
           width: 140px;
           height: 17px;
           background: ${({ theme }) => theme.blueyGrey22};
           border-radius: 2px;
        `
    };
`

export const IconWrap = styled.div`
    margin-left: 10px;
    svg {
        height: 20px;
    }
`